import { useEffect } from "react";
import { useApp } from "@/context/AppContext";

// Sets document title + meta description per page, per language.
export default function useSEO(titles, descriptions) {
  const { lang } = useApp();
  useEffect(() => {
    const title = titles[lang] || titles.fr;
    const desc = descriptions[lang] || descriptions.fr;
    document.title = title;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = desc;
  }, [lang, titles, descriptions]);
}
